import { Box, Button, Checkbox, FormControl, InputLabel, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FilterData } from '../../../interfaces/course'
import { transformString } from '../../../helpers/utils'
import FilterResetButton from '../../buttons/FilterResetButton'
const FILTER_IMAGE = 'https://members.performancegolf.com/wp-content/uploads/2025/04/filterBlack.svg'
const CLOSE_FILTER_BLACK = 'https://members.performancegolf.com/wp-content/uploads/2025/12/clear-button-mobile.svg'
const DROP_DWON_MENU_ICON = 'https://members.performancegolf.com/wp-content/uploads/2025/04/dropDownMenu.svg'

interface Props {
    handleMobileFilterToggle: ()=> void
    filterData:FilterData[],
    selectedFilters: Record<string, string[]>;  
    onFilterTypeChange: (filterType: string, isChecked: boolean,isMobile:boolean) => void;
    onFilterChange: (filterType: string, category: string) => void;
    handleResetFilter:()=>void;
    handleMobileFilterChange:(filterType: string, category: string)=>void;
}

export const FilterMobileModal = ({handleMobileFilterToggle,filterData,handleResetFilter,onFilterTypeChange,onFilterChange,selectedFilters}:Props) => {
    const theme = useTheme();
    const isTabletRange = useMediaQuery(theme.breakpoints.between(750, 900));

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [currentFilterType, setCurrentFilterType] = useState<string>('');

    useEffect(() => {
        const appHeight = () => {
            const doc = document.documentElement;
            let height = window.innerHeight;
            
            if(window.visualViewport) {
                height = window.visualViewport.height;
            }
            
            doc.style.setProperty('--app-height', `${height}px`);
        };

        window.addEventListener('resize', appHeight);
        appHeight();

        return () => {
            window.removeEventListener('resize', appHeight);
        };
    }, []);

    const handleClick = (event: React.MouseEvent<HTMLElement>, filterType: string) => {
        setAnchorEl(event.currentTarget);
        setCurrentFilterType(filterType);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleFilterChange = (filterType: string, category: string) => {
        if (category === 'all') {
            onFilterTypeChange(filterType, false, true);
        } else {
            onFilterChange(filterType, category);
        }
    };

    const resetSelectedCategories = () => {
        handleResetFilter();
    };

    const getDisplayText = (filterType: string) => {
        const selected = selectedFilters[filterType] || [];
        if (selected.length === 0) {
            return "All";
        }
        if (selected.length === 1) {
            return transformString(selected[0]);
        }
        return `${selected.length} selected`;
    };

    const isSelected = (filterType: string, category: string) => {
        return (selectedFilters[filterType] || []).includes(category);
    };

    const hasSelectedFilters = () => {
        return Object.values(selectedFilters).some(filters => filters.length > 0);
    };

    return (
        <Box sx={{
            padding:isTabletRange? '40px 70px' : '22px 16px',
            width: '100%',
            minHeight: 'calc(-54px + var(--app-height))',
            background: '#fff',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box>
                <Box display={'flex'} alignItems={'center'}>
                    <img src={FILTER_IMAGE} alt='' />
                    <Typography marginLeft={'16px'} fontSize={22} fontWeight={500} style={{fontFamily: "'Repro', sans-serif"}}>FILTER</Typography>
                    <img onClick={handleMobileFilterToggle} style={{ marginLeft: 'auto', cursor: 'pointer' }} src={CLOSE_FILTER_BLACK} alt='' />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', marginTop: '22px' }}>
                    {filterData.map((filter) => (
                        <Box key={filter.filterType} sx={{ border: '1px solid #ECE9E4', borderRadius: '7px', overflow: 'hidden', padding: '9px' }}>
                            <Box width={'100%'}>
                                <Typography color={"#B3AAA3"} fontSize={10} fontWeight={400} style={{fontFamily: "'Repro', sans-serif", textTransform: 'uppercase'}}>{filter.filterType}</Typography>
                                <Box onClick={(e: React.MouseEvent<HTMLElement>) => handleClick(e, filter.filterType)} sx={{width:'100%',cursor:'pointer',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                                    <Typography fontSize={14} color={'#000'} fontWeight={400} style={{fontFamily: "'Repro', sans-serif"}}>
                                        {getDisplayText(filter.filterType)}
                                    </Typography>
                                    <img style={{marginRight:'11px',marginBottom:'5px'}} src={DROP_DWON_MENU_ICON} alt=''/>
                                </Box>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl) && currentFilterType === filter.filterType}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    PaperProps={{
                                        style: {
                                            width: anchorEl?.clientWidth || '100%',
                                            maxHeight: '300px',
                                            overflow:'auto'
                                        },
                                    }}
                                >
                                    <MenuItem 
                                        key={`${filter.filterType}-all`}
                                        onClick={() => handleFilterChange(filter.filterType, 'all')}
                                    >
                                        <Checkbox 
                                            checked={(selectedFilters[filter.filterType] || []).length === 0}
                                            sx={{ 
                                                accentColor: '#FD3300',
                                                '&.Mui-checked': {
                                                    color: '#FD3300'
                                                }
                                            }}
                                        />
                                        All
                                    </MenuItem>
                                    {filter.data.map((el) => (
                                        <MenuItem 
                                            key={`${filter.filterType}-${el.category}`}
                                            onClick={() => handleFilterChange(filter.filterType, el.category)}
                                        >
                                            <Checkbox 
                                                checked={isSelected(filter.filterType, el.category)}
                                                sx={{ 
                                                    accentColor: '#FD3300',
                                                    fontFamily: "'Repro', sans-serif",
                                                    '&.Mui-checked': {
                                                        color: '#FD3300'
                                                    }
                                                }}
                                            />
                                            {el.title}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: isTabletRange? 'row' : 'column', gap: '10px',justifyContent:'center', marginTop:isTabletRange? '73px' :'28px' }}>
                <FilterResetButton handleResetFilter={handleResetFilter} resetSelectedCategories={resetSelectedCategories} width={isTabletRange? '236px': '100%'}/>
                <Button 
                    onClick={handleMobileFilterToggle} 
                    disabled={!hasSelectedFilters()}
                    sx={{
                        width:isTabletRange? '236px': '100%', 
                        backgroundColor: hasSelectedFilters() ? '#FD3300' : '#7B726C', 
                        color: '#fff', 
                        fontSize: '16px', 
                        fontWeight: '700', 
                        textTransform: 'none',
                        '&:disabled': {
                            backgroundColor: '#7B726C',
                            color: '#fff'
                        }
                    }} 
                    variant="contained"
                >
                    Apply
                </Button>
            </Box>
        </Box>
    );
}